/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-useless-constructor */
/* eslint-disable no-console */

import { Lessons } from '../types/lesson';
import lessonsRawJson from '../assignments/its2021.json'
import configurations from '../../copilot-cfg.json';
import { envServers, EnvsType, Servers, setLokiParams} from 'its-pages';

interface Config {
  suppressFluentdLogs: boolean;
  log: boolean;
  dashboardStart: string;
  showTourOnStart: boolean;
}

const env = import.meta.env.MODE;
const mode: EnvsType = env === 'production' ? 'Prd' : env === 'staging' ? 'Stg' : 'Local';
// const mode: EnvsType = 'Prd'
class AppCfg extends Servers {
  public get env(): EnvsType {
    return mode;
  }

  public get isProd(): boolean {
    return mode === 'Prd';
  }

  public get suppressFluentdLogs(): boolean {
    //return AppCfg.config.suppressFluentdLogs;
    return true;
  }
  public get log(): boolean {
    return AppCfg.config.log;
  }

  public get lessons(): Lessons {
    return AppCfg.lessons;
  }

  public get showTourOnStart(): boolean {
    return AppCfg.config.showTourOnStart;
  }
  
  private constructor() {
    super(mode);
  }

  public get dashboardStart(): number{
    return (new Date(AppCfg.config.dashboardStart)).getTime();
  }

  private static instance: AppCfg;
  private static config: Config = {
    ...configurations[mode], ...envServers[mode]
  };

  private static lessons: Lessons = fixupJsonReferences(lessonsRawJson).lessons;

  public static getInstance(): AppCfg {
    if (!AppCfg.instance) {
      AppCfg.instance = new AppCfg();
      setLokiParams({
        url: AppCfg.instance.getServerHref('loki'),
        src: AppCfg.instance.getSrc('loki'),
        bugReportSrc: AppCfg.instance.getBugReportSrc()
      });
    }

    return AppCfg.instance;
  }

  public consoleLog(s: any): void {
    if (AppCfg.config.log) {
      console.log(s);
    }
  }

  public ASSERT_LOG(condition: () => boolean, log: any): void {
    if (this.log && condition()) {
      console.log(log);
    }
  }
}

function fixupJsonReferences(json: any, obj?: any): any {
  obj = obj || json;

  if (typeof obj !== 'object') return;

  Object.keys(obj).forEach((key) => {
    let value = obj[key];

    if (typeof value === 'string' && value[0] === '#') {
      value = json[value.slice(1)];
    }

    if (typeof value === 'object') {
      value = fixupJsonReferences(json, value);
    }

    obj[key] = value;
  });

  return obj;
}

export const APP_CFG = AppCfg.getInstance();
